import { Typography } from "@mui/material"
import { AuthBannerWrapper, BannerLeft, BannerRight } from "./Atom"
import styles from "../../../styles/Login.module.css"
import ProntoBannerImg from "../../../assets/images/Group 35216.svg"

type Props = {}

const AuthBanner = (props: Props) => {
  return (
    <AuthBannerWrapper>
      <BannerLeft>
        <Typography
          fontSize={"80px"}
          color={"#fff"}
          fontWeight={400}
          sx={{ lineHeight: "90px" }}
        >
          Dentistry's <br />
          Practice <br />
          Performance <br />
          System
        </Typography>
        {/* <Typography fontSize={"22px"} color={"#707070"} fontWeight={400}>
          Most advance tool to help your dental <br /> business thrive
        </Typography> */}
      </BannerLeft>
      {/* <BannerRight>
                <img
                    className={styles.LoginBannerImg}
                    src={ProntoBannerImg}
                    alt="Pronto Banner Image"
                />
            </BannerRight> */}
    </AuthBannerWrapper>
  )
}

export default AuthBanner
